import type { QueryClient } from '@tanstack/react-query';
import { CertificateTemplateType } from '@/types/certificate-template.types';

/**
 * Refreshes only the certificate-template data a change touched, so one action
 * does not re-download every type. Lists always refresh; per-type lookups only for `type`.
 */
export function invalidateTemplateQueries(
  queryClient: QueryClient,
  type: CertificateTemplateType | undefined,
  options: { inUse: boolean; deletedCount: boolean }
) {
  return queryClient.invalidateQueries({
    predicate: ({ queryKey }) => {
      if (queryKey[0] !== 'certificateTemplates') return false;
      // Type unknown → refresh everything (safe fallback)
      if (!type) return true;
      if (queryKey[1] === 'in-use') return options.inUse && queryKey[2] === type;
      if (queryKey[1] === 'of-type') return queryKey[2] === type;
      if (queryKey[1] === 'deleted-count') return options.deletedCount;
      return true; // paginated lists
    }
  });
}
